// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2-T78","content":"ManualTimeModal_content__1qxWk"};